import { startsWith } from 'lodash-es';
import localStore from 'store';

import { useMainStore } from '@/stores/main';

import * as log from '../logger';

const prefix = 'k10.setting.';

export function set(name: string, value: unknown): void {
  const store = useMainStore();
  log.info('Saving global setting: ', name, value);
  store.settings[name] = value;
  localStore.set(`${prefix}${name}`, value);
}

export function get(name: string): unknown {
  const store = useMainStore();
  return store.settings[name];
}

export function loadSettingsFromLocalStorage(): void {
  const store = useMainStore();
  localStore.each((value: unknown, key: string) => {
    if (startsWith(key, prefix)) {
      const name = key.split(prefix)[1];
      log.info('Loading global setting: ', key, name, value);
      store.settings[name] = value;
    }
  });
}
